<div class="o-media o-media--sm c-content" [ngClass]="{'o-media--link': !vm.isMinimal}">
	<div class="o-media__img">
		<div class="c-thumb">
			<div *ngIf="vm.isServiceProvider || !vm.chat.activeAiSessionId" class="c-image c-image--bg c-image--round" [ngClass]="{'c-image--sm': !vm.isMinimal, 'c-image--smer': vm.isMinimal}" [ngStyle]="{ 'background-image': 'url(' + vm.getProfilePictureUrl(vm.chat.privateChatFriend) + ')' }"></div>
			<div *ngIf="!vm.isServiceProvider && vm.chat.activeAiSessionId" class="c-image c-image--bg c-image--round" [ngClass]="{'c-image--sm': !vm.isMinimal, 'c-image--smer': vm.isMinimal}" [ngStyle]="{ 'background-image': 'url(' + vm.getChatBotPictureUrl(vm.origin) + ')' }"></div>
			<div *ngIf="vm.isServiceProvider || !vm.chat.activeAiSessionId" class="c-thumb__extra c-thumb__extra--xs">
				<item-status [status]="vm.chat.privateChatFriend.status" [hasBorder]="true"></item-status>
			</div>
		</div>
	</div>
	<div class="o-media__body" [ngClass]="{'o-media__body--center-v': vm.isMinimal}">
		<div class="o-grid">
			<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
				<p style="overflow: hidden;text-overflow: ellipsis;max-width:180px;white-space: nowrap;" class="c-text c-text--md c-text--bold">{{ vm.chat.privateChatFriend.fullName || (vm.chat.privateChatFriend.firstname + ' ' + vm.chat.privateChatFriend.lastname) }}</p>
			</div>
			<div class="o-grid__cell o-grid__cell--center-v u-no-p">
				<p class="c-text c-text--lg">
					<span class="c-badge c-badge--s2" style="margin-top:-.25em" *ngIf="(!vm.chat.lastSeenPostId || (vm.chat.lastPost.id > vm.chat.lastSeenPostId))">1</span>
				</p>
			</div>
			<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--bottom u-no-p" *ngIf="!vm.isMinimal">
				<p class="c-text" [ngClass]="{'c-text--bold' : (!vm.chat.lastSeenPostId || (vm.chat.lastPost.id > vm.chat.lastSeenPostId))}">{{ vm.chat.lastPost.created | lastMessageTime }}</p>
			</div>
		</div>
		<div class="o-grid">
			<div class="o-grid__cell o-grid__cell--w-85 u-no-p">
				<item-message [chat]="vm.chat" [message]="vm.chat.lastPost" [isMessageOnly]="true" [isBold]="!vm.chat.lastSeenPostId || (vm.chat.lastPost.id > vm.chat.lastSeenPostId)" *ngIf="!vm.isMinimal" [isPreview]="true"></item-message>
			</div>
			<div class="o-grid__cell o-grid__cell--w-15 u-no-p" style="display: flex; align-items: center; justify-content: flex-end;">
				<img id="robotIcon" *ngIf="vm.chat.activeAiSessionId" src="https://dqs3afosyxqoy.cloudfront.net/assets/shared/robot-icon.svg">
				<img id="interventionIcon" *ngIf="vm.isServiceProvider && vm.chat.aiStatus==='CRITICAL_INTERVENTION_REQUIRED'" src="https://dqs3afosyxqoy.cloudfront.net/assets/shared/critical-flag.svg">
				<img id="criticalInterventionIcon" *ngIf="vm.isServiceProvider && vm.chat.aiStatus==='INTERVENTION_REQUIRED'" src="https://dqs3afosyxqoy.cloudfront.net/assets/shared/alert-flag.svg">
				<img id="forwardIcon" *ngIf="vm.isServiceProvider && vm.chat.aiStatus==='SUMMARY_FORWARD_REQUIRED'" src="https://dqs3afosyxqoy.cloudfront.net/assets/shared/forward-icon.svg">
			</div>
		</div>
	</div>
</div>
